export default defineNuxtRouteMiddleware((to, from) => {
  // console.log('restoring token:')
  // console.table({ to, from })
  
  if (to.query.sessionToken) {
    useVisitorSession().setToken(to.query.sessionToken as string)
    const { sessionToken, ...restQuery } = to.query
    // console.log('restQuery', restQuery)
    // navigateTo({ query: restQuery })
    const newUrl = {
      path: to.path,
      query: restQuery
    }
    // console.log('new to ->>> ', newUrl)
    return navigateTo(newUrl, {
      replace: true
    })
  }
  // console.log('restore token from query end.')
})
